"use client"

import { useEffect, useRef } from "react"

import { getPdpPriceView } from "@/lib/money/pdp-pricing"
import type { StoreProduct } from "@/platform/api/store-contract"
import { useScreenVisible } from "@/platform/app-mode/use-screen-visible"
import { buildGA4ItemFromProduct, priceEventParams } from "@/platform/observability/analytics/v2/mappers"
import { trackViewItem } from "@/platform/observability/analytics/v2/search"

export const PdpAnalytics = ({ product }: { product: StoreProduct }) => {
  const visible = useScreenVisible()
  const trackedProductId = useRef<string>(undefined)

  useEffect(() => {
    if (!visible || !product.id || trackedProductId.current === product.id) return
    trackedProductId.current = product.id
    trackViewItem({ ...priceEventParams(getPdpPriceView({ product })?.amount), items: [buildGA4ItemFromProduct(product)] })
  }, [product, visible])

  return null
}
